import { gql } from '@apollo/client';

export const GET_ALL_COMPANIES = gql`
	query GetAllCompanies(
		$page: Int!
		$limit: Int!
		$filters: CompanyFilterInput
		$sort: [SortInput]
	) {
		companies(
			filters: $filters
			pagination: { page: $page, limit: $limit }
			sort: $sort
		) {
			items {
				id
				gorkoId
				name
				city {
					id
					gorkoId
					name
				}
				isGorkoCommission
				isGorkoAbonent
				isGorkoHidden
				isGorkoDeleted
				salesTarget
				commissionPriority
				isGroup
				groupLinksAsGroup {
					id
					unlinked
					company {
						id
						gorkoId
						name
						city {
							name
						}
						isGorkoCommission
						isGorkoAbonent
						isGorkoHidden
						isGorkoDeleted
						salesTarget
						commissionPriority
						worth {
							id
							value
							valueAuto
						}
					}
				}
				groupLinksAsMember {
					id
					unlinked
					group {
						id
						groupLinksAsGroup {
							unlinked
							company {
								id
								gorkoId
								name
								city {
									name
								}
								isGorkoCommission
								isGorkoAbonent
								isGorkoHidden
								isGorkoDeleted
								salesTarget
								commissionPriority
								worth {
									id
									value
									valueAuto
								}
							}
						}
					}
				}
				status {
					id
					name
					code
				}
				statusTransitions {
					lossReason
					postponedReason
					postponedUntil
					toStatus {
						code
					}
					createdAt
				}
				cache {
					postponedUntil
				}
				statusAt
				objections {
					id
					solved
					comment
					createdAt
				}
				worth {
					id
					value
					valueAuto
				}
				createdAt
				updatedAt
			}
			pagination {
				currentPage
				totalPages
				totalCount
			}
		}
	}
`;
